import Environment from './environment';
import stgConfig from "../../../../config";

export default class BasePaths {
  ENV_DEV = 'dev';
  ENV_STAGING = 'staging';
  ENV_PRODUCTION = 'production';
  env: string;
  localizedPrefix: string | boolean;

  constructor(env?: string) {
    this.env = env || Environment.getEnvironment();
    this.localizedPrefix = this.getLocalizedPrefix();
  }

  getLocalizedPrefix() {
    let languagePrefix = window.location.hostname.split('.')[0];
    if (languagePrefix === 'www' || languagePrefix === 'wac'  || languagePrefix === 'qa-wac'  || languagePrefix === 'localhost') {
      return false;
    }
    return languagePrefix;
  }

  wrapForI18n(url: string) {
    if(!this.localizedPrefix) {
      return url;
    }
    return url.replace('//www.', `//${this.localizedPrefix}.`);
  }

  // WAC
  wacBasePath() {
    let base = {
      production: this.wrapForI18n('https://www.atlassian.com'),
      staging: `${window.location.hostname.indexOf('qa-wac') > -1 ? 'https://qa-wac.internal.atlassian.com' : stgConfig.stgWacInternalUrl}`,
      dev: 'http://localhost:8090/wac'
    };

    let result = base.hasOwnProperty(this.env) ? base[this.env] : base.production;

    return result;
  }

  // Identity
  idBasePath() {
    let base = {
      production: 'https://id.atlassian.com',
      staging: 'https://id.stg.internal.atlassian.com',
      dev: 'http://auth.bizbox.atlassian.com:8888'
    };

    let result = base.hasOwnProperty(this.env) ? base[this.env] : base.production;

    return result;
  }

  idLoginUrl(url?: string, skipEncoding?: boolean) {
    let continueParam = this.getReturnUrl(url, skipEncoding);
    return `${this.idBasePath()}/login?continue=${continueParam}`;
  }

  idLogoutUrl(url: string) {
    let continueParam = this.getReturnUrl(url);
    return `${this.idBasePath()}/logout?continue=${continueParam}`;
  }

  idLogoutLoginUrl(url?: string) {
    let skipInitialEncoding = true;
    return this.idLogoutUrl( this.idLoginUrl(url, skipInitialEncoding) );
  }

  // MAC
  macBasePath() {
    let base = {
      production: 'https://my.atlassian.com',
      staging: 'https://my.stg.internal.atlassian.com',
      dev: 'http://my.bizbox.atlassian.com:8888'
    };

    let result = base.hasOwnProperty(this.env) ? base[this.env] : base.production;

    return result;
  }

  macConfigUrl() {
    return `${this.macBasePath()}/ondemand/config`;
  }

  // Stargate
  atlProxyBasePath() {
    let base = {
      production: '/gateway/api',
      staging: 'https://wac.stg.atlassian.com/gateway/api',
      dev: 'https://wac.stg.atlassian.com/gateway/api'
    };

    let result = base.hasOwnProperty(this.env) ? base[this.env] : base.production;

    return result;
  }

  // COFS WAC
  wacCofsBasePath() {
    let base = {
      production: '/apis/prod/cofs',
      staging: '/apis/stg/cofs',
      dev: '/apis/stg/cofs'
    };

    let result = base.hasOwnProperty(this.env) ? base[this.env] : base.production;

    return result;
  }

  // COFS WAC
  wacHamletBasePath() {
    let base = {
      production: '/hamlet/1.0',
      staging: '/apis/stg/hamlet/1.0',
      dev: '/apis/stg/hamlet/1.0'
    };

    let result = base.hasOwnProperty(this.env) ? base[this.env] : base.production;

    return result;
  }

  getReturnUrl(url?: string, skipEncoding?: boolean) {
    url = url || window.location.href;

    if (!skipEncoding) {
      url = encodeURIComponent(url);
    }
    return url;
  }

}
